import React from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import {
  useNavigate,
} from "react-router-dom";

import {
  useState,
} from "react";

import cricketImg from "../assets/sports/cricket.jpg";
import basketballImg from "../assets/sports/basketball.jpg";
import volleyballImg from "../assets/sports/volleyball.jpg";
import badmintonImg from "../assets/sports/badminton.jpg";
import taekwondoImg from "../assets/sports/taekwondo.jpg";
import chessImg from "../assets/sports/chess.jpg";
import carromImg from "../assets/sports/carrom.jpg";
import athleticsImg from "../assets/sports/athletics.jpg";
import skatingImg from "../assets/sports/skating.jpg";

const Sports = () => {
  const navigate =
    useNavigate();

  const [open, setOpen] =
    useState(false);

  const sports = [
    {
      name: "Cricket",
      image: cricketImg,
      slug: "cricket",
    },

    {
      name: "Basketball",
      image: basketballImg,
      slug: "basketball",
    },

    {
      name: "Volleyball",
      image: volleyballImg,
      slug: "volleyball",
    },

    {
      name: "Badminton",
      image: badmintonImg,
      slug: "badminton",
    },

    {
      name: "Taekwondo",
      image: taekwondoImg,
      slug: "taekwondo",
    },

    {
      name: "Chess",
      image: chessImg,
      slug: "chess",
    },

    {
      name: "Carrom",
      image: carromImg,
      slug: "carrom",
    },

    {
      name: "Athletics",
      image: athleticsImg,
      slug: "athletics",
    },

    {
      name: "Skating",
      image: skatingImg,
      slug: "skating",
    },
  ];

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* HERO */}
      <section className="bg-[#0A3470] py-20 text-center">

        <h1 className="text-5xl md:text-6xl font-bold text-white">

          SPORTS

        </h1>

        <p className="text-white/80 mt-5 text-lg">

          Physical Fitness & Team Spirit

        </p>

      </section>

      {/* SPORTS GRID */}
      <section className="bg-[#f7f9fc] py-20">

        <div className="max-w-7xl mx-auto px-5">

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">

            {sports.map((sport) => (
              <div
                key={sport.slug}
                onClick={() =>
                  navigate(
                    `/sports/${sport.slug}`
                  )
                }
                className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer group"
              >

                <div className="overflow-hidden">

                  <img
                    src={sport.image}
                    alt={sport.name}
                    className="w-full h-[260px] object-cover group-hover:scale-110 transition-all duration-500"
                  />

                </div>

                <div className="bg-[#D4A017] py-4 text-center">

                  <h3 className="text-white text-2xl font-bold">

                    {sport.name}

                  </h3>

                </div>

              </div>
            ))}

          </div>

        </div>

      </section>

      <Footer />
    </>
  );
};

export default Sports;